import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { CirculationAreaCadastral, FiltersFormCirculationArea } from './types';
import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { CadastralData } from 'shell/models/person';
import { DateTime } from 'luxon';

export const transformDataset = (values: FiltersFormCirculationArea): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: {
      value: otherValues.code || '',
      operation: Operation.EQUALS,
    },
    descrizionePostale: {
      value: otherValues.name || '',
    },
  };

  const ordersToTransform = orders || {};

  const ordersMapped: Order = {
    codice: ordersToTransform.code,
    descrizionePostale: ordersToTransform.description,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};

export const transformerListCadastral = (
  response: AxiosResponse<HttpResponseList<CadastralData>>
): Array<CirculationAreaCadastral> => {
  const list = response.data.payload.list || [];

  return list.map(
    (item) =>
      ({
        address: item.descrPostale || '',
        civic: item.numeroCivico || '',
        particle: item.particella || '',
        exponent: item.esponente?.trim() || '',
        sheet: item.foglio || '',
        subordinate: item.subalterno || '',
        dateEnd: item.dataFine ? DateTime.fromISO(item.dataFine).toFormat('dd/MM/yyyy') : '',
        dateStart: item.dataInizio ? DateTime.fromISO(item.dataInizio).toFormat('dd/MM/yyyy') : '',
        code: item.codiceAreaCirc || '',
      } as CirculationAreaCadastral)
  );
};
